module.exports = __webpack_public_path__ + "resources/img/logo_footer_nhn_cloud.3ac16664d1afbd966e446386b28b071f.png";